import {PTGC_SET_DISABLED_ACTIONS} from './../../constants';

const setDisabledActions = disabled => ({
    type: PTGC_SET_DISABLED_ACTIONS,
    disabled
});

export default setDisabledActions;